import type { WebViewerInstance } from "@pdftron/webviewer";

/**
 * Data elements of the "View" and "Measure" ribbon tabs. View-only mode hides "View" because it has
 * no grouped items and "Measure" because measurement tools count as editing tools.
 */
const VIEW_ONLY_WHITELIST = [
  "toolbarGroup-View",
  "toolbarGroup-Measure",
  "tools-header",
  "measureGroupedItems",
  "distanceMeasurementToolButton",
  "arcMeasurementToolButton",
  "perimeterMeasurementToolButton",
  "areaMeasurementToolButton",
  "ellipseMeasurementToolButton",
  "rectangularAreaMeasurementToolButton",
  "countMeasurementToolButton",
  "measurementOverlay",
  "divider-0.4",
  "stylePanelToggle",
  "stylePanel",
  "divider-0.5",
  "defaultAnnotationUtilities",
  "undoButton",
  "redoButton",
];

/** Elements that read-only mode takes away with the "Annotating" feature and the ribbon stash. */
const MEASURE_TAB_ELEMENTS = ["tools-header", "toolsHeader", "toolbarGroup-Measure"];

const getMeasurementToolNames = ({ Core }: WebViewerInstance) => [
  Core.Tools.ToolNames.DISTANCE_MEASUREMENT,
  Core.Tools.ToolNames.ARC_MEASUREMENT,
  Core.Tools.ToolNames.PERIMETER_MEASUREMENT,
  Core.Tools.ToolNames.AREA_MEASUREMENT,
  Core.Tools.ToolNames.ELLIPSE_MEASUREMENT,
  Core.Tools.ToolNames.RECTANGULAR_AREA_MEASUREMENT,
  Core.Tools.ToolNames.COUNT_MEASUREMENT,
];

/**
 * Locks the viewer down for archived projects, guests and older file versions while keeping the
 * "View" and "Measure" tabs available. Measurements taken here are a viewing aid and are never
 * stored, see the annotation change handler in ApryseViewer.
 */
export const enableReadOnlyMode = (instance: WebViewerInstance) => {
  instance.UI.addToViewOnlyWhitelist(VIEW_ONLY_WHITELIST);
  instance.UI.enableViewOnlyMode();
  instance.Core.annotationManager.enableReadOnlyMode();
  instance.UI.enableElements(MEASURE_TAB_ELEMENTS);
  instance.UI.enableTools(getMeasurementToolNames(instance));
};
